module.exports = typeof templateVars !== 'undefined' && typeof testComponentName !== 'undefined' && testComponentName === 'menu/horizontal-content-nornikel' && templateVars.config ?
				templateVars.config :
				{
	"titleParam": [
		"topMenuTitle",
		"shortTitle",
		"title"
	],
	"depthLevel": 2,
	"hoverable": false,
	"itemsNum": 4
};


//////////////////
// WEBPACK FOOTER
// ./temp/components/menu/horizontal-content-nornikel/config.yaml
// module id = 111
// module chunks = 0